import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../../feature.types";
import { buildCrudPermissions, permissionId } from "../../../shared/featureFactories";

export const DailyPaymentSummaryFeature: FeatureMetadata = {
  id: "daily-payment-summary",
  moduleName: "feesFinance",
  navigation: {
    label: "Daily Payment Summary",
    path: "/daily-payment-summary",
    icon: DocumentTextIcon,
    order: 2,
    parentId: "finance-reports",
  },
  route: {
    path: "/daily-payment-summary",
    element: lazy(() => import("./pages/DailyPaymentSummaryReport")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FinanceReports", {
    view: permissionId("FeeFinance", "FinanceReports", "dailyPaymentSummary"),
    create: permissionId("FeeFinance", "FinanceReports", "export"),
    edit: permissionId("FeeFinance", "FinanceReports", "export"),
    delete: permissionId("FeeFinance", "FinanceReports", "export"),
  }),
  readiness: "live",
};
